import React from "react";
import {
  WhmCard,
  WhmTypography,
  WhmCardContent,
  WhmBox,
  WhmChip,
  WhmAvatar,
} from "@securitize/reactjs-whm";
import { DocumentDto } from "../../../../data/types";
import {
  translationKeys,
  useTranslation,
} from "../../../../hooks/useTranslation";
import { Menu } from "./menu";
import dayjs from "dayjs";

interface Props {
  document: DocumentDto;
}

export const CardComponent: React.FC<Props> = ({ document }) => {
  const { getTranslation: t } = useTranslation();

  const { description, createdAt, tokenName, tokenLogoUrl } = document;

  return (
    <WhmCard sx={{ marginBottom: "6px" }}>
      <WhmCardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          paddingBottom: "16px !important",
        }}
      >
        <WhmBox
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "6px",
          }}
        >
          <WhmTypography variant="body2">{description}</WhmTypography>
          <WhmBox>
            <Menu document={document} isMobile={true} />
          </WhmBox>
        </WhmBox>
        <WhmBox
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <WhmTypography variant="body2" color="text.secondary">
            {dayjs(createdAt).format("DD MMM YYYY")}
          </WhmTypography>
          <WhmChip
            sx={{ borderRadius: "4px" }}
            size="small"
            component={null}
            colorVariant={"default"}
            avatar={
              tokenLogoUrl && (
                <WhmAvatar src={tokenLogoUrl} sx={{ width: 24, height: 24 }} />
              )
            }
            label={tokenName || t(translationKeys.DOCUMENT_RELATED_BY_MULTIPLE)}
          />
        </WhmBox>
      </WhmCardContent>
    </WhmCard>
  );
};
